'use strict';

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;
exports['default'] = reducer;
exports.save = save;

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var SAVE = '@@Profile/SAVE';
var SAVE_SUCCESS = '@@Profile/SAVE_SUCCESS';
var SAVE_FAIL = '@@Profile/SAVE_FAIL';

var initialState = _immutable2['default'].Map();

function reducer() {
	var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
	var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

	switch (action.type) {

		case SAVE:
			return state.set('saving', true);

		case SAVE_SUCCESS:
		case SAVE_FAIL:
			return state.set('saving', false);

		default:
			return state;
	}
}

function save(data) {
	return {
		types: [SAVE, SAVE_SUCCESS, SAVE_FAIL],
		promise: function promise(client) {
			return client.call('user.saveProfile', { data: data }, { progress: true });
		}
	};
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/modules/profile.js
 ** module id = 510
 ** module chunks = 2
 **/